module.exports = __webpack_public_path__ + "img/385862_6D8B8D_647B80_1A2E2F-256px.94774e7a.png";